export const codeTypes = {
  iptc: ['900'],
  moex: ['905'],
  spb: ['910'],
  feed: ['950', '951'],
  publication: ['902'],
  publicationTechnical: ['9029'],
  periodical: ['907'],
} as const

export const codePaths = {
  allCodes: '000000000000000000', // "Все коды"
  iptc: '900000000000000000', // "IPTC"
  regions: '082000000000000000', // "Административно-территориальные образования"
  ipOfInterfax: '950000000000000000', // "Информационная продукция ЗАО "Интерфакс"
  publicationsType: '902000000000000000', // "Направления публикаций",
  technicalPublications: '902900000000000000', // "Технологические направления"
  periodical: '907000000000000000', // "Периодические издания"
} as const

type CodeIs = {
  iptc: (code: any) => boolean
  moex: (code: any) => boolean
  spb: (code: any) => boolean
  feed: (code: any) => boolean
  publication: (code: any) => boolean
  publicationTechnical: (code: any) => boolean
  periodical: (code: any) => boolean
}
export const codeIs: CodeIs = Object.entries(codeTypes).reduce(
  (acc, [code, prefixes]) => {
    acc[code] = (code: any) => prefixes.some((p) => code?.path?.startsWith(p))
    return acc
  },
  {} as CodeIs,
)
